"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
/**
 * Data table based on Material Design Lite.
 *
 * https://getmdl.io/components/#tables-section
 */


var DataTable = function DataTable(_ref) {
  var selectable = _ref.selectable,
      hover = _ref.hover,
      sortable = _ref.sortable,
      className = _ref.className,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ["selectable", "hover", "sortable", "className", "children"]);

  return _react2.default.createElement("div", {
    className: "cdk-data-table--wrapper"
  }, _react2.default.createElement("table", _extends({
    className: (0, _classnames2.default)("cdk-data-table", {
      "cdk-data-table--selectable": selectable,
      "cdk-data-table--hover": hover,
      "cdk-data-table--sortable": sortable
    }, className)
  }, other), children));
};

DataTable.propTypes = {
  /** True to enable support for selectable rows. */
  selectable: _propTypes.bool,

  /** True to alter row color when hovered over with the mouse. */
  hover: _propTypes.bool,

  /** Enable support for sortable columns. */
  sortable: _propTypes.bool
};
DataTable.defaultProps = {
  hover: true
};
exports.default = DataTable;